import { kameleoonIframeSetupScript } from 'dotcom-core/src/scripts/KameleoonScripts';
import env from '../../env';

const kameleonScriptSource = `https://${env.KAMELEOON_SITE_CODE}.kameleoon.io/kameleoon.js`;

declare global {
  interface Window {
    kameleoonQueue: unknown[];
  }
}

export function ExperimentsScripts({
  visitorCode,
}: { visitorCode?: string | null }) {
  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `window.kameleoonQueue = window.kameleoonQueue || [];
          ${
            visitorCode
              ? `window.kameleoonQueue.push({
                level: "IMMEDIATE",
                command: () => Kameleoon.API.Visitor.setVisitorCode("${visitorCode}")
              });`
              : ''
          }
          `,
        }}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: kameleoonIframeSetupScript({
            iframeUrl: '/assets/kameleoon_static_file.html',
          }),
        }}
      />
      <script
        src={kameleonScriptSource}
        async
        /* @ts-ignore fetchPriority doesn't exist, but it is recommended by Kameleoon */
        fetchpriority="high"
      />
    </>
  );
}
